module.exports = __webpack_public_path__ + "static/media/lMurkowski.5be5d00f.jpeg";